<script setup>
import TooltipContainer from '#/general/TooltipContainer'
import AppMenu from '#/general/AppMenu'
const props = defineProps(['title', 'body', 'showInfoCircle', 'contentWidth', 'offset'])
defineEmits(['update:visible'])
</script>

<template lang="pug">
app-menu(position="fit" :content-width="contentWidth" attach-to-parent tooltip-mode :offset="offset" @update:visible="$emit('update:visible', $event)")
  template(#parent)
    slot(name="icon")
  template(#content)
    .persistentTooltipContent
      tooltip-container(:title="title" :body="body" :show-info-circle="showInfoCircle")
        template(#chip)
          slot(name="chip")
        template(#default)
          slot(name="body")
</template>

<style scoped lang="sass">
</style>
